import { createFileRoute } from "@tanstack/react-router";

import ErrorPage from "../components/pages/ErrorPage";

export const Route = createFileRoute("/error")({
    component: () => <ErrorPage error={{ error: { message: "An error occurred" } }} />,
});
